// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_7-2";
export var blackBorderOnHover = "_7-7";
export var cell = "_7-6";
export var cellContainer = "_7-3";
export var checked = "_7-8";
export var disabled = "_7-5";
export var featuredIconCellContainer = "_7-9";
export var featuredIconTextContainer = "_7-b";
export var featuredIconWrapper = "_7-a";
export var noBorder = "_7-c";
export var orangeSelectedRow = "_i-3";
export var overflowableText = "_7-0";
export var overflowableTextContainer = "_7-1";
export var row = "_9-0";
export var rowCheckboxCell = "_7-4";
export var selectableTable = "_i-2";